<template>
  <div>
    <a-button type="primary" style="margin-bottom:30px" v-print="'#req_table'"> Print</a-button>

    <div style="margin:0px auto;width:80% ">
      <table cellspacing="0" id="req_table" style="border:#000 solid 1px">
        <tr>
          <td colspan="6" style="text-align: center; border-bottom: 0px;font-size: 30px">Comerge Shipping Co Ltd</td>
        </tr>
        <tr>
          <td colspan="6" style="text-align: center;border-top: 0px">
            <h3>Payment Noticification</h3>
          </td>
        </tr>
        <tr>
          <td colspan="6" style="text-align: center;">
            <h3></h3>
          </td>
        </tr>

        <tr style="text-align: center;">
          <td style="background-color: grey;width: 16.6%;height: 40px">Department:</td>
          <td style="background-color: yellow;width: 16.6%;height: 40px">OPERATION Dept.</td>
          <td style="background-color: grey;width: 16.6%;height: 40px">Cost Category:</td>
          <td style="background-color: yellow;width: 16.6%;height: 40px">{{payout.items}}</td>
          <td style="background-color: grey;width: 16.6%;height: 40px">Ref No:</td>
          <td style="background-color: yellow;width: 16.6%;height: 40px">{{payout.ref_no}}</td>
        </tr>
        <tr style="text-align: center;">
          <td style="background-color: grey;width: 16.6%;height: 40px">Vessel:</td>
          <td style="background-color: yellow;width: 16.6%;height: 40px">{{payout.vessel_name}}</td>
          <td style="background-color: grey;width: 16.6%;height: 40px">Sequence:</td>
          <td style="background-color: yellow;width: 16.6%;height: 40px" >{{payout.sq}}</td>
          <td style="background-color: grey;width: 16.6%;height: 40px">Payment Date:</td>
          <td style="background-color: yellow;width: 16.6%;height: 40px" >{{payout.date}}</td>
        </tr>
        <tr style="text-align: center;">
          <td style="background-color: grey;width: 16.6%;height: 40px">Beneficiary:</td>
          <td colspan="5" style="height: 40px">{{payout.beneficiary}}</td>
        </tr>

        <tr>
          <td colspan="6" style="text-align: center;">
            <h3></h3>
          </td>
        </tr>

        <tr style="text-align: center;">
          <td style="background-color: grey;width: 16.6%;height: 40px">Seq:</td>
          <td colspan="3" style="background-color: grey;height: 40px">Payment Description</td>
          <td colspan="2" id="type" style="background-color: grey;height: 40px"></td>
        </tr>

        <tr style="text-align: center;">
          <td valign=top style="width: 16.6%;height: 350px;text-align: center;padding: 20px">1</td>
          <td valign=top colspan="3" style="height: 35px;text-align: center;padding: 20px" >{{payout.items}}</td>
          <td valign=top colspan="2" style="height: 350px;text-align:center;padding: 20px">{{payout.amount.toLocaleString('en-US',{ style: 'currency', currency: 'USD' })}}</td>
        </tr>

        <tr style="text-align: center;">
          <td style="width: 16.6%;height: 40px"></td>
          <td colspan="3" style="height: 40px">Total:</td>
          <td colspan="2" style="height: 40px">{{payout.amount.toLocaleString('en-US',{ style: 'currency', currency: 'USD' })}}</td>
        </tr>

        <tr style="text-align: center;">
          <td colspan="2" style="width: 25%;height: 40px">Prepared by</td>
          <td style="width: 25%;height: 40px">Check by</td>
          <td colspan="2" style="width: 25%;height: 40px">Endorsed by</td>
          <td style="width: 25%;height: 40px">Approved by</td>
        </tr>

        <tr style="text-align: center;">
          <td colspan="2" style="width: 25%;height: 80px;">
            <!-- <img width='220' height="120" src="1st.png" alt=""> -->
          </td>
          <td style="width: 25%;height: 80px;">
            <!-- <img width='220' height="120" src="2nd.png" alt=""> -->
          </td>
          <td colspan="2" style="width: 25%;height: 80px;"></td>
          <td style="width: 25%;height: 80px;"></td>
        </tr>

        <tr style="text-align: center;">
          <td style="height: 80px;"></td>
          <td style="height: 80px;"></td>
          <td valign=top colspan="2" style="height: 80px;">Account Manager</td>
          <td valign=top colspan="2" style="height: 80px;">General Manager</td>
        </tr>

        <tr style="text-align: center;">
          <td style="height: 40px;"></td>
          <td style="height: 40px;"></td>
          <td colspan="2" style="height: 40px; text-align: left;">Date:</td>
          <td colspan="2" style="height: 40px;text-align: left">Date:</td>
        </tr>
      </table>
    </div>
  </div>
</template>


<script>


export default {
  data() {
    return {
      payout:{}
    }
  },
  methods: {

  },
  mounted() {
    var uid = this.$route.params.uid;
    var sq = this.$route.params.sq;
    this.$http.post(this.$store.state.base_url + "/payout/r", { id:uid }).then(res=>{
      if(res.data.status==1){
        this.payout = res.data.data[0]
        this.payout.ref_no = "C-MV" + (this.payout.vessel_id +10000+"").substr(1,4)+"-"+this.payout.id
        this.payout.sq = sq
      }
    })
  }
};
</script>
<style >
#req_table {
  width: 100%;
}
#req_table td {
  border: #000 solid 1px;
  border-right: #000 solid 0px;
  border-bottom: #000 solid 0px;
  margin: 0px;
}
#req_table tr td:last-child {
  border-right: #000 solid 1px;
}
#req_table tr:last-child td {
  border-bottom: #000 solid 1px;
}
</style>